<template>
  <div>
    <div class="home pc_aboutus" v-if="pcShow">
      <headerTitle indexInit="7" />
      <carouselPics :pics="pics" carouselIndex="1" />
      <div class="block_div"></div>
      <!-- <titleBlock textChinese="关于我们" textEnglish="ABOUT  US" /> -->
      <div class="block_div"></div>
      <div class="wrap_aboutus wow fadeInUp">
        <el-row>
          <el-col :span="4" class="header_block"></el-col>
          <el-col :span="16">
            <div class="aboutus_img">
              <div class="aboutus_img_text">
                <img :src="require('@/assets/imgs/abimg.png')" class="server_imgs" />
                <div class="abouts_divs">
                  <div style="text-align: center;">
                    <span
                      style="color: rgb(51, 51, 51);font-size: 51px;font-family: fontface__方正书宋__42__834369831410;"
                    >ABOUT</span>
                  </div>
                  <div style="text-align: center;">
                    <span style="color: rgb(51, 51, 51);">关于我们</span>
                  </div>
                  <div style="text-align: center;">
                    <span style="color: rgb(153, 153, 153);">
                      <span style="font-size: 14px;">INTRODUCE</span>
                    </span>
                  </div>
                </div>
              </div>
              <img :src="require('@/assets/imgs/eightone.jpg')" class="server_img" />
            </div>
          </el-col>
          <el-col :span="4" class="header_block"></el-col>
        </el-row>

        <div class="block_div wow fadeInUp"></div>
        <el-row>
          <el-col :span="4" class="header_block"></el-col>
          <el-col :span="16">
            <div class="aboutus_intro">
              星沐互娱成立于2019年，是一家具有互联网基因和理念的企业。目前主营TVC、宣传片、视频课程制作、短视频代运营、多媒体展示等领域项目。
              我们拥有专业的视频制作团队、强大的渠道资源，形成全网媒体覆盖，为客户提供多渠道宣发推广支持，转化粉丝为生产力，创造可观的流量与商业价值。
            </div>
          </el-col>
          <el-col :span="4" class="header_block"></el-col>
        </el-row>
      </div>
      <div class="block_div"></div>
      <titleBlock textChinese="企业服务" textEnglish="ENTERPRISE  SERVICE" />
      <div class="block_div"></div>
      <aboutustab />
      <div class="block_div"></div>

      <footerBlock />
    </div>
    <div v-if="!pcShow" class="mobile_aboutus">
      <mobileHeader  indexInit="7" />
      <mobileCarousel :pics="images" carouselIndex="1" />
      <mobileDivBlock />
      <div class="wrap_aboutus wow fadeInUp">
        <el-row>
          <el-col :span="1" class="header_block"></el-col>
          <el-col :span="22">
            <div class="aboutus_img">
              <div class="aboutus_img_text">
                <img :src="require('@/assets/mobileImg/aboutus.png')" class="server_imgs" />
                <!-- <div class="abouts_divs">
                  <div style="text-align: center;">
                    <span
                      style="color: rgb(51, 51, 51);font-size: 51px;font-family: fontface__方正书宋__42__834369831410;"
                    >ABOUT</span>
                  </div>
                  <div style="text-align: center;">
                    <span style="color: rgb(51, 51, 51);">关于我们</span>
                  </div>
                  <div style="text-align: center;">
                    <span style="color: rgb(153, 153, 153);">
                      <span style="font-size: 14px;">INTRODUCE</span>
                    </span>
                  </div>
                </div> -->
              </div>
              <img :src="require('@/assets/imgs/eightone.jpg')" class="server_img" />
            </div>
          </el-col>
          <el-col :span="1" class="header_block"></el-col>
        </el-row>

        <div class="block_div wow fadeInUp"></div>
        <el-row>
          <el-col :span="1" class="header_block"></el-col>
          <el-col :span="22">
            <div class="aboutus_intro">
              星沐互娱成立于2019年，是一家具有互联网基因和理念的企业。目前主营TVC、宣传片、视频课程制作、短视频代运营、多媒体展示等领域项目。
              我们拥有专业的视频制作团队、强大的渠道资源，形成全网媒体覆盖，为客户提供多渠道宣发推广支持，转化粉丝为生产力，创造可观的流量与商业价值。
            </div>
          </el-col>
          <el-col :span="1" class="header_block"></el-col>
        </el-row>
      </div>
      <mobileDivBlock />
      <mobileTitleBlock textChinese="企业服务" textEnglish="ENTERPRISE  SERVICE" />
      <mobileDivBlock />
      <mobileaboutustab />
      <mobileDivBlock />
      <mobilefooterBlock />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselPics from "@/components/carouselPics.vue";
import headerTitle from "@/components/headerTitle.vue";
import titleBlock from "@/components/titleBlock.vue";
import serviceBlock from "@/components/serviceBlock.vue";
import videoBlock from "@/components/videoBlock.vue";
import serviceProgress from "@/components/serviceProgress.vue";
import serviceClient from "@/components/serviceClient.vue";
import footerBlock from "@/components/footerBlock.vue";
import serviceAdvanced from "@/components/serviceAdvanced.vue";
import aboutustab from "@/components/aboutustab.vue";
import mobileHeader from "@/components/mobileHeader.vue";
import mobileCarousel from "@/components/mobileCarousel.vue";
import mobileDivBlock from "@/components/mobileDivBlock.vue";
import mobileTitleBlock from "@/components/mobileTitleBlock.vue";
import mobilefooterBlock from "@/components/mobilefooterBlock.vue";
import mobileaboutustab from "@/components/mobileaboutustab.vue";

export default {
  name: "Home",
  data() {
    return {
      pics: [
        {
          url: require("@/assets/imgs/banner801.jpeg"),
          linerow: 8,
          text:
            '<span style="font-size:54px;color:#fff">竭尽全力的为客户提供</span><span style="font-size:62px;color:#e91d62">影像解决方案</span>'
        }
        // { url: require("@/assets/imgs/banner02.jpeg"), text: "你好" },
        // { url: require("@/assets/imgs/banner03.jpeg"), text: "你好" },
        // { url: require("@/assets/imgs/banner04.jpeg"), text: "你好" }
      ],
      videoArray: [
        [
          {
            url: require("@/assets/imgs/video01.jpeg"),
            text: "2020体彩竞猜广告-去赛场篇"
          },
          {
            url: require("@/assets/imgs/video02.jpeg"),
            text: "郎佳子彧的手工课"
          }
        ],
        [
          {
            url: require("@/assets/imgs/video03.jpeg"),
            text: "2020体彩竞猜广告-去赛场篇"
          },
          {
            url: require("@/assets/imgs/video04.jpeg"),
            text: "郎佳子彧的手工课"
          }
        ],
        [
          {
            url: require("@/assets/imgs/video05.jpeg"),
            text: "2020体彩竞猜广告-去赛场篇"
          },
          {
            url: require("@/assets/imgs/video06.jpeg"),
            text: "郎佳子彧的手工课"
          }
        ],
        [
          {
            url: require("@/assets/imgs/video07.jpeg"),
            text: "2020体彩竞猜广告-去赛场篇"
          },
          {
            url: require("@/assets/imgs/video08.jpeg"),
            text: "郎佳子彧的手工课"
          }
        ]
      ],
      pcShow: true,
      images: [
        {
          url: require("@/assets/imgs/banner801.jpeg"),
          linerow: 8,
          text:
            '<span style="font-size:16px;color:#fff">竭尽全力的为客户提供</span><span style="font-size:16px;color:#e91d62">影像解决方案</span>'
        }
      ]
    };
  },
  components: {
    carouselPics,
    headerTitle,
    titleBlock,
    serviceBlock,
    videoBlock,
    serviceProgress,
    serviceClient,
    footerBlock,
    serviceAdvanced,
    aboutustab,
    mobileHeader,
    mobileCarousel,
    mobileDivBlock,
    mobileTitleBlock,
    mobilefooterBlock,
    mobileaboutustab
  },
  mounted() {
    this.widthChange();
    window.addEventListener("resize", this.widthChange);
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live: true
      }).init();
    });
  },
  methods: {
    widthChange() {
      console.log(123333);
      let clientWidthW = document.body.clientWidth;
      console.log(this.pcShow, "999000this.pcShow");
      console.log(clientWidthW, "9900");
      if (clientWidthW < 768) {
        this.pcShow = false;
      } else {
        this.pcShow = true;
      }
    }
  }
};
</script>
<style lang="less">
.pc_aboutus{
.wrap_aboutus {
  .header_block {
    min-height: 10px;
  }
  .aboutus_intro {
    text-align: center;
    color: "#333333";
    font-size: 15px;
    line-height: 35px;
  }
  .aboutus_img {
    display: flex;
    .aboutus_img_text {
      width: 20%;
      margin-right: 10%;
      position: relative;
      .server_imgs {
        width: 100%;
      }
      //   background: url('../assets/imgs/abimg.png') center no-repeat;
      // background-size: cover;
    }
    .server_img {
      width: 100%;
    }
    .abouts_divs {
      position: absolute;
      left: 0;
      top: -36px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      display: flex;
      width: 100%;
      height: 100%;
    }
    .server_img {
      width: 70%;
    }
  }
}
}



.mobile_aboutus{
.wrap_aboutus {
  .header_block {
    min-height: 10px;
  }
  .aboutus_intro {
    text-align: center;
    color: "#333333";
    font-size: 15px;
    line-height: 35px;
  }
  .aboutus_img {
    display: flex;
    .aboutus_img_text {
      width: 25%;
      margin-right: 10%;
      position: relative;
      .server_imgs {
        width: 100%;
      }
      //   background: url('../assets/imgs/abimg.png') center no-repeat;
      // background-size: cover;
    }
    .server_img {
      width: 100%;
    }
    .abouts_divs {
      position: absolute;
      left: 0;
      top: -36px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      display: flex;
      width: 100%;
      height: 100%;
    }
    .server_img {
      width: 65%;
    }
  }
}
}
</style>
